<div class="accordion-list">
  <ng-content></ng-content>
</div>
